import { useCallback } from "react";
import { Breadcrumbs } from "~/components/UI";
import Contracts from "./Components/Contracts";
import { useTranslation } from "react-i18next";

/**
 * @namespace ContractsPage
 */

const ContractsPage = () => {
  const { t } = useTranslation();

  const getBreadcrumbs = useCallback(() => {
    return [{ label: t("title.catalogs") }, { label: t("title.contracts") }];
  }, [t]);

  return (
    <>
      <Breadcrumbs links={getBreadcrumbs()} />
      <Contracts />
    </>
  );
};

export default ContractsPage;
